export default "__VITE_ASSET__DJYfxGdE__"